import React from 'react';
import { GameState } from '../../../../../services/api';
import SituationPanel from '../../../../Common/SituationPanel';
import NumberPanel from '../../../../Common/NumberPanel';
import UpdatablePlayersList from '../../../../Common/UpdatablePlayersList';
import { useTranslation } from 'react-i18next';

interface ActingPlayerViewProps {
  gameState: GameState;
  currentPlayerOrder: any[];
  currentSituationPlayerName: string;
}

const ActingPlayerView: React.FC<ActingPlayerViewProps> = ({
  gameState,
  currentPlayerOrder,
  currentSituationPlayerName
}) => {
  const { t } = useTranslation();
  // If game is in results state, show the results view
  if (gameState.state === 'results') {
    return (
      <div className="space-y-6">
        <SituationPanel 
          situation={gameState.currentSituation}
          variant="compact"
        />

        <UpdatablePlayersList
          players={currentPlayerOrder}
          onOrderChange={() => {}}
          title=""
          instructions=""
          showChangeIndicator={false}
          disabled={true}
          results={gameState.results}
        />

        {gameState.scoreResult && (
          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 text-center space-y-2">
            <p className="text-lg font-bold text-green-800">
              {t('game.score')} {gameState.scoreResult.score} / {gameState.scoreResult.totalPlayers}
            </p>
          </div>
        )}

        <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 text-center">
          <p className="text-blue-800 font-medium">
            ⏳ Waiting for <span className="font-bold">{currentSituationPlayerName}</span> to start the next round...
          </p>
        </div>
      </div>
    );
  }

  // Waiting view during guessing phase
  return (
    <div className="space-y-6">
      <SituationPanel 
        situation={gameState.currentSituation}
        variant="compact"
      />

      <NumberPanel
        number={gameState.assignedNumber}
        maxNumber={gameState.players.length-1}
        variant="result"
      />

      <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 space-y-3">
        <p className="text-blue-800 text-center font-medium">
          <span className="font-bold">{currentSituationPlayerName}</span> {t('game.isNowGuessing')}
        </p>
      </div>
    </div>
  );
};

export default ActingPlayerView;